import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DISPLAY_STATUS, STATUS_OBJECT } from 'src/app/dummy/status';
import { Router, ActivatedRoute } from '@angular/router';
import { PrintService } from 'src/app/services/print.service';
import { BOOK_STORE_TABS } from 'src/app/dummy/tab';
import { APPS, COLLECTION_NAME } from 'src/app/dummy/app';
import { FormControl } from '@angular/forms';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';

@Component({
  selector: 'app-trending',
  templateUrl: './trending.component.html',
  styleUrls: ['./trending.component.scss']
})
export class TrendingComponent implements OnInit {
  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  displayStatus = DISPLAY_STATUS
  tabs = BOOK_STORE_TABS.TRENDING;
  page: any;
  status: any;
  search: any;
  size = APPS.SIZE
  DISPLAY_STATUS_KEY: any;
  searchTextBox = new FormControl(null, []);

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public store: BookstoreStore,
    public ps: PrintService,
  ) { }

  async ngOnInit() {
    this.route.params.subscribe(async (param) => {
      this.DISPLAY_STATUS_KEY = STATUS_OBJECT[param['id']];
      this.store.fetchData(COLLECTION_NAME.BOOK_STORE_TRENDING, this.DISPLAY_STATUS_KEY.key)
    })
  }

  create() {
    this.router.navigate([`/book-store/trending/data/draft`])
  }


}
